import { render, staticRenderFns } from "./PromotionsView.vue?vue&type=template&id=a8d3cdfa&scoped=true&"
import script from "./PromotionsView.vue?vue&type=script&lang=js&"
export * from "./PromotionsView.vue?vue&type=script&lang=js&"
import style0 from "./PromotionsView.vue?vue&type=style&index=0&id=a8d3cdfa&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8d3cdfa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCol,VImg,VRow,VSkeletonLoader,VTextField})
